import "./Impact.module.css";
import Header from "@/reusable_sections/Header";
import DataThatDrivesChange from "./sections/DataThatDrivesChange";
import VoicesOfProsperity from "./sections/VoicesOfProsperity";
import AnnualReportArchive from "./sections/AnnualReportArchive";
import Footer from "@/reusable_sections/Footer";
export default function ImpactPage() {
  return <div>
      <Header />
      <DataThatDrivesChange />
      <VoicesOfProsperity />
      <AnnualReportArchive />
      <Footer />
    </div>;
}